// app/javascript/offcanvas_forms.js
import * as bootstrap from "bootstrap";

function csrfToken() {
  const meta = document.querySelector('meta[name="csrf-token"]');
  return meta && meta.content;
}

function openOffcanvasWith(url, title = "", useModal = false) {
  const bodyId = useModal ? "drawer-modal-body" : "drawer-body";
  const labelId = useModal ? "drawerModalLabel" : "drawerLabel";
  const containerId = useModal ? "drawer-modal" : "drawer-offcanvas";

  const body = document.getElementById(bodyId);
  const label = document.getElementById(labelId);
  if (!body || !label) {
    window.location.href = url;
    return;
  }

  label.textContent = title || "";
  body.innerHTML = '<div class="text-muted text-center py-5">Carregando…</div>';

  fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
    .then(r => r.text())
    .then(html => {
      body.innerHTML = html;
    })
    .catch(() => {
      body.innerHTML = '<div class="text-danger">Falha ao carregar.</div>';
    });

  const el = document.getElementById(containerId);
  if (!el) return;
  if (useModal) {
    const modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  } else {
    const off = bootstrap.Offcanvas.getOrCreateInstance(el);
    off.show();
  }
}

function handleDelegatedClicks(e) {
  const a = e.target.closest("a.js-offcanvas-link");
  if (!a) return;
  e.preventDefault();
  const modalEl = document.getElementById("drawer-modal");
  const offcanvasEl = document.getElementById("drawer-offcanvas");
  const useModal = a.dataset.modal === "true" || (modalEl && !offcanvasEl);
  openOffcanvasWith(a.href, a.dataset.title, useModal);
}

function handleDelegatedSubmits(e) {
  const form = e.target.closest("form.js-offcanvas-form");
  if (!form) return;
  e.preventDefault();
  const modalEl = document.getElementById("drawer-modal");
  const offcanvasEl = document.getElementById("drawer-offcanvas");
  const useModal = form.dataset.modal === "true" || (modalEl && !offcanvasEl);

  const formData = new FormData(form);
  const method = (form.querySelector('input[name="_method"]')?.value || form.method || "post").toUpperCase();

  fetch(form.action, {
    method: method === "GET" ? "POST" : method, // PATCH/POST
    headers: {
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-Token": csrfToken()
    },
    body: formData
  })
    .then(async (r) => {
      if (r.ok && r.headers.get("content-type")?.includes("application/json")) {
        const json = await r.json();
        if (json.ok) {
          if (json.reload) {
            window.location.reload();
            return;
          }

          // atualiza/insere a linha
          const targetId = form.dataset.tbodyId || "event-types-tbody";
          const tbody = document.getElementById(targetId);
          const temp = document.createElement("tbody");
          temp.innerHTML = json.row_html.trim();
          const row = temp.querySelector("tr");
          if (row) {
            if (tbody) {
              const existing = document.getElementById(row.id);
              if (existing) {
                existing.replaceWith(row);
              } else {
                tbody.prepend(row);
              }
            } else {
              window.location.reload();
            }
          }
          // fechar offcanvas
          const el = document.getElementById(useModal ? "drawer-modal" : "drawer-offcanvas");
          if (el) {
            const instance = useModal ? bootstrap.Modal.getInstance(el) : bootstrap.Offcanvas.getInstance(el);
            instance && instance.hide();
          }
        } else {
          // fallback: reload
          window.location.reload();
        }
      } else if (r.status === 422) {
        // voltou o form com erros (HTML)
        const html = await r.text();
        const body = document.getElementById(useModal ? "drawer-modal-body" : "drawer-body");
        if (body) {
          body.innerHTML = html;
        } else {
          window.location.reload();
        }
      } else {
        // algo inesperado
        window.location.reload();
      }
    })
    .catch(() => window.location.reload());
}

document.addEventListener("click", handleDelegatedClicks);
document.addEventListener("submit", handleDelegatedSubmits);
